$('.main__map__parter .map__main__row--14 .map__main__col--left .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})

$('.main__map__parter .map__main__row--14 .map__main__col--left--extra .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})


$($('.main__map__parter .map__main__row--14 .map__main__col--right .seat-ctn .state').get().reverse()).each(function(index){
    $(this).css('transform', 'rotate('+ (index*1) +  'deg)')
})

$($('.main__map__parter .map__main__row--14 .map__main__col--right--extra .seat-ctn .state').get().reverse()).each(function(index){
    $(this).css('transform', 'rotate('+ (index*1) +  'deg)')
})

$('.main__map__parter .map__main__row--14 .map__main__col--left .seat-ctn').curve({"x1":30,"y1":200,"x2":55,"y2":200,x3: 85, y3: 0})
$('.main__map__parter .map__main__row--14 .map__main__col--right .seat-ctn').curve({"x1":30,"y1":200,"x2":55,"y2":200,x3: 85, y3: 0})
$('.main__map__parter .map__main__row--14 .map__main__col--left--extra .seat-ctn').curve({"x1":30,"y1":200,"x2":55,"y2":200,x3: 85, y3: 0})
$('.main__map__parter .map__main__row--14 .map__main__col--right--extra .seat-ctn').curve({"x1":30,"y1":200,"x2":55,"y2":200,x3: 85, y3: 0})